<template>
    <div class="progress td-progress-bar">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" :style="'width: ' + progress + '%;'">

        </div>
    </div>

</template>

<script>
    import Vue from 'vue'


    export default {
        props: {
            progress: {
                type: Number,
                required: true
            }
        },
        data() {
            return {

            }
        },
        created() {
            let vm = this;



        },

        methods: {
        }

    }

</script>


<style lang="scss">
    .td-progress-bar {

    }



</style>



// WEBPACK FOOTER //
// src/components/appLoader/components/progressBar.vue